import React from "react"
import HeaderDescription from "@/components/common/Header&Description"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getPaddingsClassFromData } from "@/utils/utils"
import List from "@/components/ExpandingListAndDescription/List"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled(GridContainer)`
	row-gap: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		row-gap: ${getCssSizeValue(30, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		row-gap: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)};
	}
`

const ExpandingListAndeDescription = ({ data }) => {
	const id = data?.id || ""
	const headerDescription = data?.headerDescription || {}
	const moreText = data?.moreText || ""
	const lessText = data?.lessText || ""
	const paddings = getPaddingsClassFromData(data)
	const list = data?.list || []
	return (
		<Wrapper key={id} id={id} className={`${paddings}`}>
			<HeaderDescription data={headerDescription} className="col-mobile-8 col-desktop-6" />
			<List data={list} moreText={moreText} lestText={lessText} className="col-mobile-8 col-desktop-10" />
		</Wrapper>
	)
}

export default ExpandingListAndeDescription
